AgrimarketControllers.controller('ceremisDashboardController', [
    '$scope', '$sce', 'authenticationService',
    function ($scope, $sce, authenticationService) {
        authenticationService.GetUrlWithTokenForDashboardsInCeremis(function (url) {
            $scope.targetUrl = $sce.trustAsResourceUrl(url.replace('"', '').replace('"', ''));
        });
    }
]);